import { c as _c } from "react/compiler-runtime";
import { type LumiSurveyConfig, LumiSurveyDock, type LumiSurveyTransport } from "@navikt/lumi-survey";
import { opprettSurveyFeedback } from "@/server/actions/opprettSurveyFeedback";
const transport: LumiSurveyTransport = {
  async submit(submission) {
    await opprettSurveyFeedback(submission.transportPayload);
  }
};
interface Props {
  feedbackId: string;
  survey: LumiSurveyConfig;
}
export const Lumi = t0 => {
  const $ = _c(3);
  const {
    feedbackId,
    survey
  } = t0;
  let t1;
  if ($[0] !== feedbackId || $[1] !== survey) {
    t1 = <LumiSurveyDock surveyId={feedbackId} survey={survey} transport={transport} />;
    $[0] = feedbackId;
    $[1] = survey;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};